import { capitalize } from 'transfix-ui/core'
import { titleCase } from 'utils/titleCase'

/**
 * @description Converts the status of a carrier to the new status mappings
 * @example
 * getNewCarrierStatus('In Review') // 'Needs Review'
 */
export const getNewCarrierStatus = (status: string, enabled: boolean = true) => {
  if (!enabled) {
    return status
  }

  const isUppercase = status === capitalize(status)
  const lowerStatus = status.toLowerCase()

  let newStatus = lowerStatus

  switch (lowerStatus) {
    case 'in review':
      newStatus = 'needs review'
      break

    case 'canceled':
    case 'cancelled':
      newStatus = 'failed review'
      break

    case 'activated':
      newStatus = 'active'
      break

    case 'application submitted':
    case 'app submitted':
    case 'app. submitted':
      newStatus = 'app submitted'
      break

    case 'expired ins':
    case 'expired ins.':
    case 'expired insurance':
      newStatus = 'incomplete'
      break

    default:
      break
  }

  return isUppercase ? titleCase(newStatus) : newStatus
}
